export default "__VITE_ASSET__MVbdWZyG__"